<template>
  <div>

    <h2 class="m-b-20 section-title" v-if="!minimalMode">{{ !isQuoteMode ? $t('which_goods_are_you_shipping') : $t('LBL_CONTAINTS_DANGEROUS_GOODS') }}</h2>

    <div class="card m-b-40">
      <div class="row" v-if="!isQuoteMode && !minimalMode">
        <div>
          <Toggle
            class="m-r-10"
            :id="`shipment-content-toggle-${parseInt(useShipmentContentLevelToggle)}`"
            :label="$t('add_content_lines_for_entire_shipment')"
            :value="!!useShipmentContentLevelToggle"
            @change.native="toggleUseContentOnShipmentLevel"
          /> {{ $t('add_content_lines_for_entire_shipment') }}
          <Toggle
            class="m-l-40  m-r-10"
            :id="`colli-content-toggle-${parseInt(useShipmentContentLevelToggle)}`"
            :label="$t('add_content_lines_for_each_colli')"
            :value="!useShipmentContentLevelToggle"
            @change.native="toggleUseContentOnShipmentLevel"
          /> {{ $t('add_content_lines_for_each_colli') }}
        </div>
      </div>
      <div class="row">
        <div v-if="useContentOnShipmentLevel && !isQuoteMode && !minimalMode" class="row m-b-25 m-t-25">
          <div :class="'col-xs-12'">
            <DescriptionPicker
              :label="$t('desc')"
              v-model="value.description"
            />
          </div>
        </div>
        <!-- PACKAGE OPTIONS -->
        <div v-if="useContentOnShipmentLevel && showColliContent  && !isQuoteMode">
          <div class="separator" v-if="!minimalMode"></div>
          <!-- CONTENT ROW -->
          <div  class="row m-b-40">
            <h2 class="col-xs-12 content-title m-b-20" v-if="!minimalMode">{{ $t('content_lines_for_entire_shipment') }}</h2>
            <div class="col-xs-12">
              <ContentRow
                :class="value.content.length > (index + 1) ? 'm-b-20' : ''"
                :showOnlyDescription="showOnlyDescription"
                :showOrigin="showOrigin"
                :showCustoms="showCustoms"
                :isCustomsInvoiceUploaded="isCustomsInvoiceUploaded"
                v-for="(item, index) in value.content" :key="`shipment-content-${index}`"
                :deletable="value.content.length > 1"
                :indexInData="index"
                @setProductDetails="productSelected"
                @removeProduct="productRemoved"
                @quantityChange="quantityChange"
                @deleteRow="deleteContentRow(index)"
                v-model="value.content[index]"
              />
            </div>
          </div>

          <div class="separator" v-if="!minimalMode"></div>
          <!-- CONTENT ROW OPTIONS -->
          <div class="row m-t-30">
            <div class="col-xs-6">
              <Btn @click.native="addContentItem"
                   class="brand float-left m-r-20"
                   :icon="{ name: 'plus', size: '20'}"
                   :btnText="$t('Add content')"
              />
            </div>
            <div class="col-xs-6 float-right"
                 style="text-align: right; padding-top: 5px">
              <p>{{ $t('total_value')}} {{ totalContentAmount | currency(null, safeCurrency.toUpperCase()) }}</p>
            </div>
          </div>
        </div>
        <booking-dg-block
          v-if="useContentOnShipmentLevel && !minimalMode"
          :value="value"
          :custom-id="customId"
          :show-separator="!isQuoteMode"
          :label="isQuoteMode ? 'LBL_DANGEROUS_GOODS_YES' : null"
          :dg-type-shown-on-package-custom-id="dgTypeShownOnPackageCustomId"
          :show-temperature="showTemperature"
          :show-dangerous-goods="showDangerousGoods"
          @input="$emit('input', $event)"
        />
      </div>
      </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import mixin from '@/mixins/mixins';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";

import ContentRow from "@/components/shipments/contentRow.vue";
import DangerousGoodsBlock from "@/components/shipments/dangerousGoodsBlock";
import GoodsType from "@/components/shipments/goodsType.vue";
import ProductPicker from "@/components/global/productPicker/productPicker.vue";
import productSelect from "@/mixins/productSelect";
import BookingDgBlock from "@/components/shipments/bookingDgBlock.vue";
import DescriptionPicker from "@/components/global/productPicker/descriptionPicker.vue";

export default {
  name: 'ShipmentContentBlock',
  mixins: [mixin, productSelect],
  components: {
    BookingDgBlock,
    ProductPicker,
    GoodsType,
    Btn,
    InputSelect,
    InputText,
    Toggle,
    WeightSelect,
    ContentRow,
    DangerousGoodsBlock,
    DescriptionPicker,
  },
  props: {
    isQuoteMode: {
      type: Boolean,
      default: false,
    },
    minimalMode: {
      type: Boolean,
      default: false,
    },
    useContentOnShipmentLevel: {
      type: Boolean,
      default: true,
    },
    isCustomsInvoiceUploaded: {
      type: Boolean,
      default: false,
    },
    dgTypeShownOnPackageCustomId: {
      type: String,
      default: '',
    },
    isShipmentInEdit: {
      type: Boolean,
      default: false,
    },
    showColliAmount: {
      type: Boolean,
      default: false,
    },
    showColliDescription: {
      type: Boolean,
      default: true,
    },
    showColliContent: {
      type: Boolean,
      default: false,
    },
    showTemperature: {
      type: Boolean,
      default: false,
    },
    showDangerousGoods: {
      type: Boolean,
      default: false,
    },
    customId: {
      type: String,
      default: '',
    },
    showOnlyDescription: {
      type: Boolean,
      default: false,
    },
    showOrigin: {
      type: Boolean,
      default: false,
    },
    showCustoms: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return{
          goodsType: 1,
          colli: 1,
          description: '',
          parcelType: '',
          packagingName: '',
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: '',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          packingTypeOption: 2,
          isOverpack: 0,
          allPackedInOne: 2,
          iataLimitations: '',
          iataRadioactive: '',
          iataAdditionalInfo: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ],
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      totalContentAmount: 0
    }
  },
  computed: {
    ...mapGetters([
      'get_parcel_types',
      'get_editing_shipment',
    ]),
    useShipmentContentLevelToggle() {
      return this.useContentOnShipmentLevel;
    },
    safeCurrency() {
      const unit = this.value.content[0]?.unitValue?.unit?.toLowerCase();
      if (['kg', 'g', 'lb', 'oz'].includes(unit)) {
        console.warn('ShipmentContentBlock: Invalid currency unit detected in display:', unit);
        return 'dkk';
      }
      return unit || 'dkk';
    }
  },
  methods: {
    toggleUseContentOnShipmentLevel(val) {
      this.$emit('toggleUseContentOnShipmentLevel', val);
    },
    addContentItem(){
      let weightUnit = 'kg';
      let currencyUnit = 'dkk';
      if (this.value.content.length) {
        weightUnit = this.value.content[0].unitWeight.unit;
        currencyUnit =  this.safeCurrency;
      }
      this.$emit('input', {
        ...this.value,
        content: [...this.value.content, {
          qty: 1,
          description: '',
          unitWeight: {
            value: '',
            unit: weightUnit,
          },
          unitValue: {
            value: '',
            unit: currencyUnit,
          },
          hsCode: '',
          origin: '',
        }]
      });
    },
    removeParcel() {
      this.$emit('removeParcel');
    },
    deleteContentRow(index) {
      const obj = JSON.parse(JSON.stringify(this.value))
      const contentArray = obj.content.filter((item, idx) => idx !== index)

      this.$emit('input', {
        ...obj,
        content: contentArray,
      });
    },
  },
  mounted() {
    this.totalContentAmount = this.calculateTotalContentAmount(this.value.content);
  },
  watch: {
    'showColliContent' (newVal, oldVal) {
      if (this.value && newVal && this.value.content.length < 1) {
        this.addContentItem()
      }
    },
    'value.content': {
      handler(newVal){
        if (newVal) {
          this.totalContentAmount = this.calculateTotalContentAmount(newVal);
        }
      },
      deep: true
    },
  }
}
</script>
